import React, { useEffect, useState } from "react";
import classes from "./PointHeader.module.scss";
import pointTitleImage from "../../static/images/point/point-title.png";

type PointHeaderProps = {
  aquiredPoint: number;
};

const PointHeader = ({ aquiredPoint }: PointHeaderProps) => {
  return (
    <>
      <div className={classes.container}>
        <div className={classes.title}>
          <img src={pointTitleImage} alt={pointTitleImage} />
        </div>
        <div className={classes.point}>
          <span className={classes.number}>{aquiredPoint}</span>
          <span className={classes.text}>pt</span>
        </div>
      </div>
    </>
  );
};

export default PointHeader;
